import React from 'react'
import ReactDOM from 'react-dom'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'
import Hero from '../../../site/layout/component/Hero'

const debug = require('debug')('hero')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme
    document.querySelectorAll('.js-hero').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <Hero {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
